  <template >
   <div class="formPosition" v-role="'ped'">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col>

              <h4 style="text-align:center;"> <span> Painel de Transferência  - Pedidos de Transferências</span></h4>
   <label>
       Solicitações Pendentes
      <v-chip
        class="ma-2"
        color="pink"
        text-color="white"
      >
        {{solicitacoes_pendentes.length}}
      </v-chip>
   </label>

<div class="text-center">
  <div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

 <v-container fluid>
    <v-row align="center">
       <v-col class="d-flex" cols="3" sm="4">

        <v-select
          v-model="select1"
          :items="solicitacoes_pendentes"
          item-value="idMatricula"
          item-text="nomeEstudante"
          :rules="ruleRequired"
          @change="SelecionaEntidade()"
          label="Estudantes pendentes"
        ></v-select>

      </v-col>
      <v-col class="d-flex" cols="4" sm="4">
         <v-select
          v-model="turma"
          :items="turmasFiltered"
          item-value="pkTurma"
          item-text="turmadescricao"
          :rules="ruleRequired"
          :disabled="select1 === null || disabilita"
          @change="CarregaAlunos()"
          label="Selecione a Turma"
        ></v-select>
      </v-col>

      <v-col class="d-flex" cols="3" sm="2">
         <v-btn color="blue" :disabled="turma === 0 || disabilita" style="color:white" @click="save()">
              Confirmar
         </v-btn>
      </v-col>

        <v-col class="d-flex" cols="4" sm="2">

        <v-progress-circular
        v-if="progresso"
        indeterminate
        color="green"
    ></v-progress-circular>
      </v-col>

    </v-row>

  </v-container>
    </div>
      </v-col>
    </v-row>

      <v-dialog
      v-model="dialog"
      max-width="410"
    >
      <v-card>
        <v-card-title class="headline"><v-icon color="blue">info</v-icon>  Alerta</v-card-title>

        <v-card-text>
          Ao efectuar a Transferência , <strong>não será possivel</strong> inverter a operação!
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="SaveTransferencia()"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

     <v-card
    class="mx-auto"
  >
    <v-list-item>
      <v-list-item-avatar color="grey"></v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Dados do Estudante </v-list-item-title>
        <v-list-item-subtitle>Pesquisa Local - Estudante</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

<v-row>
  <v-col md="6">
    <v-card-text>
      <strong> Dados Pessoais</strong>
    </v-card-text>
    <hr>
    <v-row>
     <v-col md="6">
          <v-chip color="error" style="margin:4px;color:white">Nome:{{(this.estudante_dados.length)?(this.estudante_dados[0].nome):''}}</v-chip>
     </v-col>
     <v-col md="6">
          <v-chip color="error" style="margin:4px;color:white">Matricula:{{(this.estudante_dados.length)?(this.estudante_dados[0].idMatricula):''}}</v-chip>
     </v-col>
    </v-row>
    <v-row>
     <v-col md="4">
          <v-chip style="margin:4px">Genero:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].sexo):''}}</strong></v-chip>
     </v-col>
     <v-col md="8">
          <v-chip style="margin:4px">Data de Nascimento:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].datanascimento):''}}</strong></v-chip>
     </v-col>
    </v-row>
     <v-row>
     <v-col md="6">
          <v-chip style="margin:4px">Natural de :<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedopai):''}}</strong></v-chip>
     </v-col>
     <v-col md="6">
          <v-chip style="margin:4px">BI:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].bi):''}}</strong></v-chip>
     </v-col>
    </v-row>

     <v-row>
     <v-col md="6">
          <v-chip style="margin:4px">Filho de :<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedopai):''}}</strong></v-chip>
     </v-col>
     <v-col md="6">
          <v-chip style="margin:4px">e De:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedamae):''}}</strong></v-chip>
     </v-col>
    </v-row>

     <v-row>
     <v-col md="12">
          <v-chip style="margin:4px">Contacto:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].telefone):''}}</strong></v-chip>
     </v-col>
    </v-row>

    <v-row>
    <v-col md="2"></v-col>
     <v-col md="10">
        <v-chip color="error" style="margin:4px;color:white">instituição Proveniente:{{(this.estudante_pendente.length)?(this.estudante_pendente[0].instituicao_proveniente):''}}</v-chip>     </v-col>
    </v-row>

    <hr>
  </v-col>
  <v-col md="6">
    <v-card-text>
      <strong> {{titulo}}</strong>
    </v-card-text>
    <hr>

    <v-data-table
            :headers="headers"
            :items="estudante_dados"
          >

      </v-data-table>

  </v-col>
</v-row>
  </v-card>

  </v-container>

</template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
export default {
  data: () => ({

    solicitacoes_pendentes: [],
    turmasAll: [],
    classe: 0,
    disabilita: false,
    dialog: false,
    turma: 0,
    turmasFiltered: [],
    select1: null,
    estudante_pendente: [],
    pesquisa_parameto: null,
    idinstproveniente: 0,
    estudante_dados: [],
    disabilita_ano: true,
    funcionarios: [],
    select_anolectivo: null,
    idMatricula: null,
    estudante: true,
    progresso: false,
    Pessoas: [],
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    ruleRequired: [value => value || 'campo obrigatorio'],
    items1: [
      'Aluno',
      'Funcionário'
    ],
    items2: [
      'Nome',
      'Bilhete de Identidade',
      'Número de Matricula'
    ],
    ano: [
      '2017',
      '2018',
      '2019',
      '2020'
    ],
    headers: [
      { text: 'Curso - Inscrito ', value: 'descricao_curso' },
      { text: 'Classes( Feitas )', value: 'idTurma' },
      { text: 'Turma', value: 'descricao_turma' },
      { text: 'Ano Lectivo', value: 'anoLectivo' },
      { text: 'Aproveitamento', value: 'resultado' }
    ],

    headersf: [
      { text: 'Ano de Admissão ', value: 'descricao_curso' },
      { text: 'Função', value: 'idAno_Academico' }
    ]

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initialize()
    this.initializeturmasAll()
  },
  methods: {

    async initialize (searchInDb) {
      try {
        this.isLoading = true

        if (!searchInDb) {
          var payload = '{"anoacademico":"' + null + '","find":"all"}'
        } else {
          var payload = '{"anoacademico":"' + null + '","find":"' + searchInDb + '"}'
        }

        this.solicitacoes_pendentes = await axios
          .get('/Listar_solicitacoes')
          .then(res => res.data)
        this.isLoading = false
        console.log(this.solicitacoes_pendentes)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    SelecionaEntidade () {
      setTimeout(() => {
        this.estudante_pendente = this.solicitacoes_pendentes.filter(t => t.idMatricula === this.select1)
        if (this.estudante_pendente.length) // Seta os campos
        {
          this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === this.estudante_pendente[0].idCurso && t.idAno_Academico == this.estudante_pendente[0].idanoacademico)
          this.classe = this.estudante_pendente[0].idanoacademico
          this.idinstproveniente = this.estudante_pendente[0].idinstituicaoProveniencia
          this.SelecionaAluno()
        }
      }, 0)
    },

    async  SaveTransferencia () {
      let obj_turma = this.turmasFiltered.filter(t => t.pkTurma === this.turma) // Turma selecionada

      //= ================================ VERIFICA SE O ALUNO =============================================================

      try {
        this.progresso = true
        this.Pessoas = await axios
          .get('/Verifica_inscricao/' + this.select1)
          .then(res => res.data)
        this.progresso = false
        console.log(this.Pessoas)
      } catch (error) {
        this.progresso = false
      }

      //= =============================== FIM DESSA VERIFICAÇÃO ============================================================
      if (this.Pessoas.length && obj_turma.length) // Se encontrar ==== Apenas Actaliza a instituição em Pessoa e fkTurma , idTurma e outros em inscrição na turma
      {
        let dados = {
          idmatricula: this.Pessoas[0].idMAtricula,
          fkTurma: obj_turma[0].pkTurma,
          idturma: obj_turma[0].idTurma,
          pkinscricao_na_turma: this.Pessoas[0].pkInscricao_na_turma,
          inscrito: 1
        }

        try {
          this.progresso = true
          let msg = await axios
            .post('/Actualiza_Pessoa_transferencia', dados)
            .then(res => res.data)
          this.progresso = false
          this.Limpar(msg)
          this.text = msg
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
        } catch (error) {
          this.progresso = false
        }
        this.dialog = false
      } else // Se não tiver feito ja uma inscrição , lhe é feito uma nova inscrição - ( confirmação de matricula )
      {
        if (obj_turma) {
          // Faz a nova inserção
          const valores =
                    {
                      idmatricula: this.select1,
                      idturma: obj_turma[0].idTurma,
                      pkPessoa: this.estudante_dados[0].pkPessoa,
                      idanolectivo: (obj_turma[0].idAnoLectivo === null) ? 10 : obj_turma[0].idAnoLectivo,
                      pkTurma: obj_turma[0].pkTurma,
                      idcurso: obj_turma[0].idCurso,
                      bi: this.estudante_dados[0].bi,
                      idanoacademico: obj_turma[0].idAno_Academico,
                      resultado: (this.estudante_dados[this.estudante_dados.length - 1].resultado === 'Transita') ? 1 : 0,
                      descricao_resultado: this.estudante_dados[this.estudante_dados.length - 1].resultado,
                      fromtransferencia: 1
                    }

          try {
            this.progresso = true
            let msg = await axios
              .post('/confirmacaoInsertOrUpdate', valores)
              .then(res => res.data)
            this.text = msg
            this.Limpar(msg)
            this.progresso = false
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
          } catch (error) {
            this.progresso = false

            this.text = error
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
          }

          this.dialog = false
        }
      }

      //= ==========================================================================================================================
    },

    Limpar (msg) {
      if (msg === 'TRANSFERÊNCIA EFECTUADA COM SUCESSO' || msg === 'CONFIRMAÇÃO EFECTUADA COM SUCESSO') {
        const index = this.solicitacoes_pendentes.indexOf(this.estudante_pendente)
        this.solicitacoes_pendentes.splice(index, 1)
        this.select1 = ''
        this.disabilita = true
        this.turma = ''
        this.estudante_pendente = []
        this.estudante_dados = []
      }
    },

    async save () {
      this.dialog = true
    },

    async verifica_Inscricao () {

    },

    async Actualiza_Dados_Transferencia (obj_turma) {
      let dados = {
        idmatricula: this.Pessoas[0].idMAtricula,
        fkTurma: obj_turma[0].pkTurma,
        idturma: obj_turma[0].idTurma,
        pkinscricao_na_turma: this.Pessoas[0].pkInscricao_na_turma,
        inscrito: 0
      }

      try {
        this.progresso = true
        let msg = await axios
          .post('/Actualiza_Pessoa_transferencia', dados)
          .then(res => res.data)
        this.progresso = false
        this.Limpar(msg)
        this.text = msg
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
      } catch (error) {
        this.progresso = false
      }
    },

    async CarregaAlunos () {
      if (this.select_anolectivo != null) {
        try {
          this.progresso = true
          this.Pessoas = await axios
            .get('/pessoaFind/' + this.select_anolectivo)
            .then(res => res.data)
          this.progresso = false
          console.log(this.Pessoas)
        } catch (error) {
          this.progresso = false
        }
      }
    },

    async SelecionaAluno () {
      if (this.select1 != null && this.idinstproveniente !== 0) {
        // CarregaInscrição na turma
        try {
          this.estudante_dados = await axios
            .get('/PesquisaInstituicaoEspecifica/' + this.select1 + '/' + this.idinstproveniente)
            .then(res => res.data)
          console.log(this.estudante_dados)
        } catch (error) {
          this.progresso = false
        }
      }
    },

    async initializeturmasAll () {
    //  turmaFindWithEstudanteCount
      const ls = require('local-storage')
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll')
          .then(res => res.data)
        console.log(this.turmasAll)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }

  }

}

</script>
